module.exports = __webpack_public_path__ + "static/media/YF86_05.671aa1d7.jpg";